import OtherPromo from 'ui/components/molecules/OtherPromo';
import Link from 'next/link';
import { MdArrowForward } from 'react-icons/md';
import useIsNativeView from 'ui/hooks/useIsNativeView';
import { triggerNativeMessage } from '../../../helpers/utils';
import useImpressionProductKnowledgeDetail from '../../../hooks/emarsys/product-knowledge/useImpressionProductKnowledgeDetail';
import eventClickProductKnowledgeDetail from '../../../helpers/emarsys/product-knowledge/eventClickProductKnowledgeDetail';
import { useRef } from 'react';
import useImpressionNewsDetail from 'ui/hooks/emarsys/news/useImpressionNewsDetail';
import eventClickNewsDetail from 'ui/helpers/emarsys/news/eventClickNewsDetail';

const DetailArticleAnotherPromoSection = ({
  handleCollectDataLayer,
  anotherPromo,
  handleShowModalExpiredPromo,
  feature = '',
  emarsysData = {
    breadcrumbs: [],
    titlePage: '',
    publishedDate: '',
  },
  impressionData = {
    breadCrumb: [],
    article: null,
  },
}: any) => {
  const impressionRef = useRef(null);
  const isNativeView = useIsNativeView();

  if (feature === 'PRODUCT_KNOWLEDGE_DETAIL') {
    useImpressionProductKnowledgeDetail(
      impressionRef,
      emarsysData?.titlePage,
      emarsysData?.breadcrumbs,
      emarsysData?.publishedDate,
      'promo terkait'
    );
  }

  const PUBLIC_URL = process.env.NEXT_PUBLIC_URL;

  const handleSeeAll = () => {
    // if (typeof window !== 'undefined') {
    //   (window as any)?.androidApp?.goToPromoList();
    //   (window as any)?.webkit?.messageHandlers?.iosApp?.postMessage('goToPromoList');
    // }
    triggerNativeMessage('goToPromoList');
  };

  if (feature === 'NEWS_DETAIL') {
    useImpressionNewsDetail(
      impressionRef,
      impressionData?.article,
      impressionData?.breadCrumb,
      'promo terkait'
    );
  }

  return anotherPromo?.length ? (
    <section className="my-4 mt-2 md:mt-8 lg:my-16" ref={impressionRef}>
      <div className="container lg:p-0">
        <div className="flex items-center justify-between mb-1 lg:mb-6">
          <p className="text-base font-bold uppercase text-reliableBlack lg:text-2xl">
            Promo Terkait
          </p>

          <Link
            id="link-semua-promo"
            href={`${PUBLIC_URL}/promosi`}
            onClick={(e) => {
              if (isNativeView) {
                e.preventDefault();
              }
              handleSeeAll();
              if (feature === 'PRODUCT_KNOWLEDGE_DETAIL') {
                eventClickProductKnowledgeDetail(
                  emarsysData?.titlePage,
                  emarsysData?.breadcrumbs,
                  emarsysData?.publishedDate,
                  'promo terkait',
                  'lihat semua'
                );
              }
              if (feature === 'NEWS_DETAIL') {
                eventClickNewsDetail(
                  impressionData?.article,
                  impressionData?.breadCrumb,
                  'lihat semua',
                  'promo terkait'
                );
              }
            }}
            className="bg-transparent text-reliableBlack text-xs font-semibold uppercase lg:text-base lg:font-medium"
          >
            <span className="flex items-center gap-2 lg:gap-4">
              Lihat semua
              <MdArrowForward color="#CE181E" size={18} />
            </span>
          </Link>
        </div>

        {/* Another promo card */}
        <OtherPromo
          categoryGTM={'promo terkait'}
          handleCollectDataLayer={handleCollectDataLayer}
          items={anotherPromo}
          handleShowModalExpiredPromo={handleShowModalExpiredPromo}
        />
      </div>
    </section>
  ) : null;
};

export default DetailArticleAnotherPromoSection;
